<template>
  <div id="flip-item-status">
    <v-row>
      <v-col md=6>
        <v-card flat tile>
          <v-card-title>{{ adminAsset.title }}</v-card-title>
          <v-card-text>
            <v-img :src="adminAsset.images.find(i => i.type === 'mainImage').smallUri"></v-img>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md=6>
        <assetHistoryDetailsList></assetHistoryDetailsList>
      </v-col>
    </v-row>
    <assetShareholders></assetShareholders>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import assetHistoryDetailsList from '../components/AssetHistoryDetailsList'
  import assetShareholders from '../components/AssetShareholders.vue'

  export default {
    name: 'FlipHistory',

    components: {
      assetHistoryDetailsList,
      assetShareholders
    },

    computed: {
      ...mapGetters([
        'adminAsset',
        'adminAssetHistory'
      ])
    },

    methods: {
      ...mapActions([
        'getPurchaseHistoryForAsset',
        'clearPurchaseHistoryForAsset'
      ])
    },

    async created() {
      this.clearPurchaseHistoryForAsset()
      await this.getPurchaseHistoryForAsset(this.adminAsset.id)
    }
  }
</script>
